import { Toaster } from 'sonner';
export function FeedbackToaster() {
  return <><Toaster position="top-right" richColors closeButton duration={4000} visibleToasts={3}
    offset={16} mobileOffset={12} toastOptions={{ className: 'mts-feedback-toast ph-no-capture ph-sensitive' }} />
    <style>{`.mts-feedback-toast { overflow-wrap: anywhere; font-family: inherit; }
@media (prefers-reduced-motion: reduce) { [data-sonner-toaster] [data-sonner-toast] { transition: none !important; animation: none !important; } }`}</style></>;
}
